import {
  FC,
  memo,
  useEffect,
  useMemo,
} from 'react';
import fastCompare from 'react-fast-compare';
import { SeoBreadcrumbType } from '@edikk-edikk/country-frontend';
import { useAppDispatch } from '#components/redux';
import { addBreadcrumb, removeBreadcrumb } from '#baseBreadcrumbs/reducers';

const Breadcrumb: FC<SeoBreadcrumbType> = ({
  id,
  title,
  to,
  state,
}) => {
  const breadcrumb = useMemo<SeoBreadcrumbType>(() => ({
    id,
    title,
    to,
    state,
  }), [id, title, to, state]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(addBreadcrumb(breadcrumb));

    return () => {
      dispatch(removeBreadcrumb(breadcrumb.id));
    };
  }, [breadcrumb, dispatch]);

  return null;
};

const BreadcrumbMemoized = memo<SeoBreadcrumbType>(
  Breadcrumb,
  (
    prevProps,
    nextProps,
  ) => fastCompare(prevProps, nextProps),
);

export { BreadcrumbMemoized as Breadcrumb };
